import { getData } from "adminApi/apiClient";

const RoleFetcher = async ({
  dispatch,
  user,
  setMenuAccess,
  removeMenuAccess,
}) => {
  if (!user?.id) return;
  try {
    const role = await getData(`role/veryfication/get/${user.id}`);
    dispatch(setMenuAccess(role.data));
  } catch (error) {
    dispatch(removeMenuAccess());
  }
};

export default RoleFetcher;
